import React, { useState } from 'react';
import './contact.css'
import Modal from './Modal';

const Contact = ({ projectId }) => {

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <button className='open-modal-btn' onClick={() => {
        setModalOpen(true);
      }}>Kontakta oss för mer information</button>
      {modalOpen && <Modal setOpenModal={setModalOpen} projectId={projectId} />}

    </>
  );
};
export default Contact